import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function Layout() {
  const { user, isAdmin, signOut } = useAuth();

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand">
          <span className="logo">-</span>
          <span>Checklist ESDM</span>
        </div>

        <NavLink to="/patients" className="nav-link">
          👤 Pacientes
        </NavLink>
        <NavLink to="/relatorios" className="nav-link">
          📊 Relatórios
        </NavLink>
        {isAdmin && (
          <NavLink to="/admin/therapists" className="nav-link">
            🧑‍⚕️ Terapeutas
          </NavLink>
        )}
        {isAdmin && (
          <NavLink to="/admin/users" className="nav-link">
            ⚙️ Usuários
          </NavLink>
        )}

        <div className="spacer" />

        <div className="user-chip">
          <div style={{ fontWeight: 600, color: 'var(--text)' }}>
            {user?.displayName ?? user?.email}
          </div>
          <div>{isAdmin ? 'Administrador' : 'Terapeuta'}</div>
          <button
            className="btn ghost sm"
            style={{ marginTop: 8, paddingLeft: 0 }}
            onClick={() => void signOut()}
          >
            Sair
          </button>
        </div>
      </aside>

      <main className="main">
        <div className="content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
